import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import saveLocalTags from 'actions/tags/saveLocalTags.action';

import CreateVoucher from 'scheduler/components/VoucherView';

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ saveLocalTags }, dispatch);
}

function mapStateToProps(state) {
  const { currentSalon } = state;

  return { salonId: currentSalon.id };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateVoucher);
